var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{key:_vm.iframeSrc,staticStyle:{"border":"none"},attrs:{"src":_vm.iframeSrc,"width":"100%","height":"99%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }